import {
  createLazyContext,
  useLazyContextProvider,
  useRequiredContext,
} from "@redotech/react-util/context";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { RedoMarketingRpcClientContext } from "@redotech/redo-merchant-app-common/marketing-rpc-client-provider";
import { MinimalCustomerGroup } from "@redotech/redo-model/customers/customer-group-definition";
import { MarketingPermissions } from "@redotech/redo-model/permissions";
import { memo, ReactNode } from "react";

export const SegmentsContext = createLazyContext<MinimalCustomerGroup[]>();
export const SegmentsService = memo(function SegmentsService({
  children,
}: {
  children: ReactNode | ReactNode[];
}) {
  const client = useRequiredContext(RedoMarketingRpcClientContext);
  const canViewMarketing = useHasPermission(
    MarketingPermissions.VIEW_MARKETING,
  );
  const loadState = useLazyContextProvider(async (signal) => {
    if (!canViewMarketing) {
      return [];
    }
    return await client.getCustomerGroupsMinimal({}, { signal });
  });

  return (
    <SegmentsContext.internalContext.Provider value={loadState}>
      {children}
    </SegmentsContext.internalContext.Provider>
  );
});
